import { render, staticRenderFns } from "./file-detail.vue?vue&type=template&id=40da6379&scoped=true"
import script from "./file-detail.vue?vue&type=script&lang=js"
export * from "./file-detail.vue?vue&type=script&lang=js"
import style0 from "./file-detail.vue?vue&type=style&index=0&id=40da6379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da6379",
  null
  
)

export default component.exports